module.exports = __webpack_public_path__ + "img/SCC_CD4Tconv.24d61004.png";